import { resolveApplicationFees } from "@/lib/applicationFees";

const money = (v, cur) => `${cur} ${Number(v).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
const PER = { university: "one charge per university", campus: "one charge per campus" };

function ChargeRow({ c, uniName }) {
  const amount = c.state === "waived" ? "Waived" : c.state === "no_fee" ? "No fee"
    : c.min !== c.amount ? `${money(c.min, c.currency)}–${money(c.amount, c.currency)}` : money(c.amount, c.currency);
  return (
    <li className="py-2 border-b border-stone-100 last:border-0" data-testid={`app-fee-charge-${c.key}`}>
      <div className="flex justify-between gap-3 text-sm">
        <span className="text-stone-800">{uniName} · {c.channel}</span>
        <span className="font-mono text-stone-900">{amount}</span>
      </div>
      <div className="text-[11px] text-stone-500 leading-snug">
        {PER[c.charged_per] || c.charged_per} · covers {c.degree_ids.length} shortlisted course{c.degree_ids.length > 1 ? "s" : ""} · {c.as_of}
        {c.amount_international != null && <> · International applicants: {money(c.amount_international, c.currency)}</>}
        {c.condition && <> · <span className="text-stone-700">{c.condition}</span></>}
        {c.waiver && <> · Waiver: {c.waiver} (not applied automatically)</>}
        {c.source_url && <> · <a href={c.source_url} target="_blank" rel="noopener noreferrer" className="underline">source</a></>}
      </div>
    </li>
  );
}

export function ApplicationFeesSection({ items, applicant }) {
  const rows = (items || []).map((it) => ({ degree_id: it.degree_id, university_id: it.university_id,
    level: it.degree?.level, application_fee: it.degree?.application_fee }));
  const r = resolveApplicationFees(rows, applicant);
  const names = Object.fromEntries((items || []).map((it) => [it.university_id, it.university?.name || it.university_id]));
  return (
    <section className="mt-8 rounded-lg border border-stone-200 bg-white p-4" data-testid="application-fees-section">
      <h3 className="font-editorial text-lg text-stone-900">One-off application fees</h3>
      <p className="text-[12px] text-stone-500">Charged per application, not per course or per year. Separate from tuition.</p>
      <ul className="mt-2">{r.charges.map((c) => <ChargeRow key={c.key} c={c} uniName={names[c.university_id]} />)}</ul>
      <div className="mt-2 text-sm text-stone-800" data-testid="application-fees-total">
        {Object.entries(r.totals).map(([cur, t]) => (
          <div key={cur}>Known total: {t.min === t.max ? money(t.max, cur) : `${money(t.min, cur)}–${money(t.max, cur)}`}</div>
        ))}
        {!r.complete && (
          <div className="text-[12px] text-amber-800" data-testid="application-fees-unknown">
            Not yet verified for {r.unknown_degree_ids.length} shortlisted course{r.unknown_degree_ids.length > 1 ? "s" : ""}, so the total is incomplete.
          </div>
        )}
      </div>
    </section>
  );
}
